import customSelect from 'custom-select'
export default {
  name: 'custom-select',

  componentDidMount () {
    const customSelectEl = customSelect(this.el, {
      containerClass: 'custom-select-container',
      openerClass: 'custom-select-opener',
      panelClass: 'custom-select-panel',
      optionClass: 'custom-select-option',
      optgroupClass: 'custom-select-optgroup',
      isSelectedClass: 'is-selected',
      hasFocusClass: 'has-focus',
      isDisabledClass: 'is-disabled',
      isOpenClass: 'is-open',
    })

    const isComparator = this.props !== undefined && this.props.isComparator

    const iconContainer = document.createElement('div')
    iconContainer.innerHTML = `
      <svg class="custom-select-icon">
        <use href="#icon-${isComparator ? 'chevron-right' : 'chevron'}" xlink:href="#icon-${isComparator ? 'chevron-right' : 'chevron'}"></use>
      </svg>
    `
    
    if (this.props !== undefined && ((this.props.isProduct && this.props.isProduct === 'true') || this.props.isLocation)) {
      const iconProductContainer = document.createElement('div')
      iconProductContainer.innerHTML = `
        <svg class="custom-select-product ${this.props.site === 'sailing' ? 'icon--coral' : 'icon--purple'}" width="24" height="24">
          <use href="#icon-${this.props.isProduct ? this.props.site : 'pin'}" xlink:href="#icon-${this.props.isProduct ? this.props.site : 'pin'}"></use>
        </svg>
      `

      customSelectEl[0].container.prepend(iconProductContainer.firstElementChild)
    }

    if (this.props !== undefined && (this.props.changeModel || this.props.hasPlaceholder)) {
      customSelectEl[0].select.addEventListener('change', (e) => {
        if (this.props.changeModel) {
          const activeCard = document.querySelector('[js-landing-card].is-active')
          activeCard.classList.remove('is-active')
          activeCard.classList.add('hidden')

          const newActiveCard = document.querySelector(`[js-landing-card][data-model="${e.target.value}"]`)
          newActiveCard.classList.add('is-active')
          newActiveCard.classList.remove('hidden')
        } else if (this.props.hasPlaceholder) {
          if (e.target.value === '') {
            this.el.parentNode.parentNode.classList.add('has-placeholder')
          } else {
            this.el.parentNode.parentNode.classList.remove('has-placeholder')
          }
        }
      })
    }

    customSelectEl[0].container.appendChild(iconContainer.firstElementChild)
  },
}
